/* eslint-disable max-len */
import {useEffect} from 'react';
import * as Sentry from '@sentry/react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType
} from 'react-router-dom';
import env from '@/constants/env';

Sentry.init({
  dsn: env.SENTRY_DSN,
  release: env.RELEASE_ID,
  environment: env.SENTRY_ENVIRONMENT,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes
    }),
    Sentry.replayIntegration()
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled.
  // The API of the current environment (staging or production) links frontend and backend
  // traces; that API must allow the sentry-trace and baggage headers (CORS).
  tracePropagationTargets: [
    /^\//,
    ...(env.ApiServerUrl ? [env.ApiServerUrl] : [])
  ],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0
});
